import React from 'react';

import { PageSpinner } from '@/shared/components/PageSpinner';

import styles from './_SeriesStructureSkeleton.module.css';

export const SeriesStructureSkeleton = () => (
    <div>
        <div className={styles.seriesNavigator} />
        <PageSpinner loadMore />
    </div>
);
